// Generated by `pnpm generate` — do not edit.
import { createIcon } from '../create-icon';

export const MinusCircleIcon = /* @__PURE__ */ createIcon(
  'minus-circle',
  { fill: 'none', viewBox: '0 0 24 24' },
  [
    [
      'path',
      {
        fill: 'currentColor',
        d: 'M21 12a9 9 0 1 0-18 0 9 9 0 0 0 18 0m-5-1a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2zm7 1c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11',
      },
    ],
  ]
);
